import { Component, Input } from '@angular/core';
import { ApplicationInfo, EnvironmentService } from '@abp/ng.core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AIDisclaimerModalComponent } from 'src/app/ai-disclaimer/ai-disclaimer-modal.component';

@Component({
  selector: 'ca-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  constructor(private environment: EnvironmentService, private modalService: NgbModal) {}

  get appInfo(): ApplicationInfo {
    return this.environment.getEnvironment().application;
  }

  openAIDisclaimer() {
    this.modalService.open(AIDisclaimerModalComponent, {
      size: 'lg',
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
  }
}
